<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part-no">Part One:</h2>
<h2 class="part-title">The Burning Platform</h2>
<h3 class="ch-sub" id="sec1"><span class="titalic">The Moment I Realized I Needed to Make a Change</span></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?62d1869a